import { useSuperadmin } from '@/hooks/useSuperadmin';
import { useAppSelector } from '@/store/hooks';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

// Iconos SVG estilo GeoTracking
const icons = {
  dashboard: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
    </svg>
  ),
  calendar: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
    </svg>
  ),
  users: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
    </svg>
  ),
  creditCard: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
    </svg>
  ),
  chart: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
    </svg>
  ),
  map: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
    </svg>
  ),
  settings: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  qrCode: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z" />
    </svg>
  ),
  userManagement: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
    </svg>
  ),
  wrench: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z" />
    </svg>
  ),
  subscription: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
    </svg>
  ),
  chevronDoubleLeft: (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
    </svg>
  ),
  chevronDown: (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  ),
  search: (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
};

interface NavItem {
  label: string;
  href: string;
  icon: React.ReactNode;
  badge?: number;
  children?: NavItem[];
}

interface NavSection {
  title: string;
  items: NavItem[];
}

export default function Sidebar() {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const isSuperadmin = useSuperadmin();
  const { organizer } = useAppSelector((state) => state.auth);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const eventId = params.id;
  const isEventMode = !!eventId && location.pathname.includes('/dashboard/events/');

  const toggleMenu = (label: string) => {
    setExpandedMenus((prev) =>
      prev.includes(label) ? prev.filter((m) => m !== label) : [...prev, label]
    );
  };

  const isActive = (href: string) => {
    if (href === `/dashboard/events/${eventId}`) {
      return location.pathname === href;
    }
    return location.pathname.startsWith(href);
  };

  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    try {
      const { performSignOut } = await import('@/lib/api');
      await performSignOut();
      navigate('/', { replace: true });
    } catch {
      navigate('/', { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  // Navegación para Superadmin
  if (isSuperadmin) {
    const superadminSections: NavSection[] = [
      {
        title: 'ACCESS CONTROL',
        items: [
          { label: 'Users', href: '/dashboard/users', icon: icons.users },
          { label: 'Admins', href: '/dashboard/admins', icon: icons.userManagement },
        ],
      },
    ];

    return (
      <SidebarContainer
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        organizer={null}
        isSuperadmin={true}
        isLoggingOut={isLoggingOut}
        handleLogout={handleLogout}
      >
        <SidebarNav
          sections={superadminSections}
          isCollapsed={isCollapsed}
          expandedMenus={expandedMenus}
          toggleMenu={toggleMenu}
          isActive={isActive}
        />
      </SidebarContainer>
    );
  }

  // Menú Global - Estilo GeoTracking
  const globalSections: NavSection[] = [
    {
      title: '',
      items: [{ label: 'Dashboard', href: '/dashboard', icon: icons.dashboard }],
    },
    {
      title: 'GESTIÓN DE EVENTOS',
      items: [
        { label: 'Mis Eventos', href: '/dashboard/events', icon: icons.calendar },
        { label: 'Pagos Pendientes', href: '/dashboard/payments', icon: icons.creditCard },
      ],
    },
    {
      title: 'OPERACIONES',
      items: [
        { label: 'Reportes', href: '/dashboard/reports', icon: icons.chart },
      ],
    },
  ];

  // Menú de Evento
  const eventSections: NavSection[] = eventId
    ? [
      {
        title: 'EVENTO',
        items: [
          { label: 'Dashboard', href: `/dashboard/events/${eventId}`, icon: icons.dashboard },
          { label: 'Equipo', href: `/dashboard/events/${eventId}?action=team`, icon: icons.users },
          { label: 'Asistentes', href: `/dashboard/events/${eventId}/attendees`, icon: icons.users },
          { label: 'Check-in', href: `/dashboard/events/${eventId}/checkin`, icon: icons.qrCode },
          { label: 'Mapa de Asientos', href: `/dashboard/events/${eventId}/map`, icon: icons.map },
          { label: 'Pagos del Evento', href: `/dashboard/events/${eventId}/payments`, icon: icons.creditCard },
          { label: 'Analíticas', href: `/dashboard/events/${eventId}/analytics`, icon: icons.chart },
        ],
      },
      {
        title: 'CONFIGURACIÓN',
        items: [{ label: 'Configuración', href: `/dashboard/events/${eventId}/edit`, icon: icons.settings }],
      },
    ]
    : [];

  return (
    <SidebarContainer
      isCollapsed={isCollapsed}
      setIsCollapsed={setIsCollapsed}
      organizer={organizer}
      isSuperadmin={false}
      isLoggingOut={isLoggingOut}
      handleLogout={handleLogout}
    >
      <SidebarNav
        sections={isEventMode ? eventSections : globalSections}
        isCollapsed={isCollapsed}
        expandedMenus={expandedMenus}
        toggleMenu={toggleMenu}
        isActive={(href) =>
          href === '/dashboard' ? location.pathname === '/dashboard' : isActive(href)
        }
      />
    </SidebarContainer>
  );
}


// Contenedor principal del Sidebar - Estilo EventFlow
function SidebarContainer({
  isCollapsed,
  setIsCollapsed,
  organizer,
  isSuperadmin,
  isLoggingOut,
  handleLogout,
  children,
}: {
  isCollapsed: boolean;
  setIsCollapsed: (v: boolean) => void;
  organizer: { organization_name: string } | null;
  isSuperadmin: boolean;
  isLoggingOut: boolean;
  handleLogout: () => void;
  children: React.ReactNode;
}) {
  return (
    <aside
      className={`
        hidden lg:flex flex-col bg-white border-r border-gray-200
        transition-all duration-300 ease-in-out relative h-screen sticky top-0 z-20
        ${isCollapsed ? 'w-[72px]' : 'w-[260px]'}
      `}
    >
      {/* Header del Sidebar - Logo EventFlow */}
      <div className={`flex items-center h-16 relative transition-all duration-300 ${isCollapsed ? 'justify-center px-0' : 'px-6'}`}>
        <div className="flex items-center gap-3">
          {/* Logo azul EventFlow - Estilo Original */}
          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
            <span className="text-white font-bold text-sm">E</span>
          </div>

          <div
            className={`transition-all duration-300 overflow-hidden flex flex-col ${isCollapsed ? 'w-0 opacity-0 hidden' : 'w-auto opacity-100'
              }`}
          >
            <span className="text-xl font-bold text-blue-600 tracking-tight ml-1">EventFlow</span>
          </div>
        </div>

        {/* Botón de colapsar/expandir - Flotante estilo circular azul en el borde */}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className={`
            absolute -right-3 top-5 w-6 h-6 bg-blue-600 hover:bg-blue-700 
            text-white rounded-full flex items-center justify-center 
            shadow-md transition-all duration-300 z-50 border-2 border-white cursor-pointer
            ${isCollapsed ? 'rotate-180' : ''}
          `}
          title={isCollapsed ? "Expandir" : "Contraer"}
        >
          <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>
      </div>





      {/* Navegación - Flex grow para ocupar espacio central */}
      <nav
        className={`flex-1 overflow-y-auto py-6 space-y-2 ${isCollapsed ? 'overflow-x-visible sidebar-scrollbar-hidden' : 'overflow-x-hidden custom-scrollbar'}`}
      >
        {children}
      </nav>

      {/* Footer - Perfil de Usuario al fondo */}
      <div className="mt-auto border-t border-gray-100 bg-white">
        {/* Sección de Usuario Estilo Tarjeta Minimalista */}
        <div className={`transition-all duration-300 ${isCollapsed ? 'p-2' : 'p-4'}`}>
          <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'gap-3'}`}>
            {/* Avatar */}
            <div className="w-9 h-9 bg-slate-100 text-slate-600 rounded-lg flex items-center justify-center flex-shrink-0 border border-slate-200">
              <span className="font-semibold text-sm">
                {isSuperadmin ? 'SA' : organizer?.organization_name?.charAt(0).toUpperCase() || 'O'}
              </span>
            </div>

            {/* Info Texto */}
            <div
              className={`transition-all duration-300 overflow-hidden flex flex-col ${isCollapsed ? 'w-0 opacity-0 hidden' : 'w-auto opacity-100'
                }`}
            >
              <p className="text-sm font-semibold text-slate-800 truncate leading-tight">
                {isSuperadmin ? 'Super Admin' : organizer?.organization_name || 'Organización'}
              </p>
              <p className="text-[11px] text-slate-400 font-medium truncate">
                {isSuperadmin ? 'Administrador' : 'Organizador'}
              </p>
            </div>
          </div>

          {/* Botón Logout estilo link discreto debajo del perfil si está expandido, o icono si colapsado */}
          <button
            onClick={handleLogout}
            disabled={isLoggingOut}
            className={`
               mt-3 flex items-center text-slate-400 hover:text-red-500 transition-colors w-full cursor-pointer relative group
               ${isCollapsed ? 'justify-center mt-2 pt-2 border-t border-gray-100' : 'gap-3 px-1'}
             `}
            title="Cerrar Sesión"
          >
            <span
              aria-hidden="true"
              className={`absolute top-1/2 -translate-y-1/2 ${isCollapsed ? 'right-2' : 'right-4'} w-[2px] h-6 bg-blue-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity`}
            />
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
            </svg>
            {!isCollapsed && <span className="text-xs font-medium">Cerrar Sesión</span>}
          </button>
        </div>
      </div>
    </aside>
  );
}

// Navegación del Sidebar - Estilo GeoTracking
function SidebarNav({
  sections,
  isCollapsed,
  expandedMenus,
  toggleMenu,
  isActive,
}: {
  sections: NavSection[];
  isCollapsed: boolean;
  expandedMenus: string[];
  toggleMenu: (label: string) => void;
  isActive: (href: string) => boolean;
}) {
  const [indicatorStyle, setIndicatorStyle] = useState<{
    top: number;
    height: number;
    opacity: number;
  }>({
    top: 0,
    height: 0,
    opacity: 0,
  });
  const navRef = useRef<HTMLDivElement>(null);
  const isHoveringRef = useRef(false);

  const updateIndicatorFromElement = (element: HTMLElement | null) => {
    const nav = navRef.current;
    if (!nav || !element) return;

    const navRect = nav.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    setIndicatorStyle({
      top: elementRect.top - navRect.top,
      height: elementRect.height,
      opacity: 1,
    });
  };

  const syncIndicatorToActive = () => {
    const activeElement = navRef.current?.querySelector<HTMLElement>(
      '[data-active="true"]',
    );

    if (activeElement) {
      updateIndicatorFromElement(activeElement);
      return;
    }

    setIndicatorStyle((prev) => ({ ...prev, opacity: 0 }));
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    isHoveringRef.current = true;
    updateIndicatorFromElement(e.currentTarget);
  };

  const handleMouseLeave = () => {
    isHoveringRef.current = false;
    syncIndicatorToActive();
  };

  useEffect(() => {
    if (!isHoveringRef.current) {
      syncIndicatorToActive();
    }
  }, [sections, isCollapsed]);

  return (
    <div ref={navRef} className="space-y-4 relative">
      <div
        className="absolute right-0 w-[2px] bg-blue-600 transition-all duration-200 ease-out rounded-full pointer-events-none z-20"
        style={{
          top: `${indicatorStyle.top}px`,
          height: `${indicatorStyle.height}px`,
          opacity: indicatorStyle.opacity,
        }}
      />

      {sections.map((section, sectionIndex) => (
        <div key={section.title || sectionIndex}>
          {/* Título de sección */}
          {section.title && (
            isCollapsed ? (
              <div className="flex justify-center my-4 group relative">
                <div className="w-8 h-[1px] bg-gray-200 group-hover:bg-blue-300 transition-colors"></div>
              </div>
            ) : (
              <p className="px-6 text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-2 mt-2 transition-all duration-300 overflow-hidden whitespace-nowrap font-sans">
                {section.title}
              </p>
            )
          )}

          {/* Items de navegación */}
          <div className="space-y-0.5">
            {section.items.map((item) => (
              <div key={item.label}>
                {item.children ? (
                  <NavMenuWithChildren
                    item={item}
                    isCollapsed={isCollapsed}
                    isExpanded={expandedMenus.includes(item.label)}
                    toggleMenu={() => toggleMenu(item.label)}
                    isActive={isActive}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  />
                ) : (
                  <NavLinkItem
                    href={item.href}
                    icon={item.icon}
                    label={item.label}
                    badge={item.badge}
                    isActive={isActive(item.href)}
                    isCollapsed={isCollapsed}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  />
                )}

                {/* Insertar Buscador Global después del Dashboard */}
                {item.label === 'Dashboard' && (
                  <div className="mt-2 mb-2">
                    <SidebarSearch
                      isCollapsed={isCollapsed}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

// Buscador Global en Sidebar
function SidebarSearch({
  isCollapsed,
  onMouseEnter,
  onMouseLeave,
}: {
  isCollapsed: boolean;
  onMouseEnter?: (e: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave?: () => void;
}) {
  return (
    <button
      onClick={() => window.dispatchEvent(new Event('open-global-search'))}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`
        relative w-full flex items-center transition-all duration-200 group cursor-pointer
        focus:outline-none focus-visible:outline-none
        text-slate-400 hover:text-blue-600
        ${isCollapsed ? 'justify-center py-3' : 'gap-4 px-6 py-3 bg-slate-50 hover:bg-blue-50 rounded-lg border border-slate-200 hover:border-blue-200'}        
      `}
      title={isCollapsed ? "Buscar" : ""}
    >
      <span className="flex-shrink-0">
        {icons.search}
      </span>
      <span
        className={`text-[13px] font-medium transition-all duration-300 overflow-hidden whitespace-nowrap ${isCollapsed ? 'w-0 opacity-0 hidden' : 'w-auto opacity-100 flex-1 text-left'
          }`}
      >
        Buscar...
      </span>
    </button>
  );
}

// Item de navegación simple - Estilo GeoTracking
function NavLinkItem({
  href,
  icon,
  label,
  badge,
  isActive,
  isCollapsed,
  isSettings,
  onMouseEnter,
  onMouseLeave,
}: {
  href: string;
  icon: React.ReactNode;
  label: string;
  badge?: number;
  isActive: boolean;
  isCollapsed: boolean;
  isSettings?: boolean;
  onMouseEnter?: (e: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave?: () => void;
}) {
  const content = (
    <>
      <span className={`flex-shrink-0 transition-colors duration-200 ${isActive ? 'text-blue-600' : 'text-slate-400 group-hover:text-slate-600'
        }`}>
        {icon}
      </span>
      <span
        className={`text-[14px] font-medium transition-all duration-300 overflow-hidden whitespace-nowrap ${isCollapsed ? 'w-0 opacity-0 hidden' : 'w-auto opacity-100 flex-1'
          }`}
      >
        {label}
      </span>
      {badge !== undefined && badge > 0 && !isCollapsed && (
        <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full min-w-[20px] text-center">
          {badge > 99 ? '99+' : badge}
        </span>
      )}
    </>
  );

  const baseClassName = `
    relative w-full flex items-center gap-4 transition-all duration-200 group cursor-pointer
    focus:outline-none focus-visible:outline-none
    ${isCollapsed ? 'justify-center py-3' : 'px-6 py-3'}
  `;

  // La línea azul se maneja con el indicador animado del SidebarNav
  const activeClassName = isActive
    ? 'bg-blue-50/80 text-blue-700'
    : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50';

  const settingsClassName = isSettings
    ? 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'
    : '';

  const className = `${baseClassName} ${isSettings ? settingsClassName : activeClassName}`;

  // Tooltip para modo colapsado - eliminado
  const tooltip = null;

  if (href === '#') {
    return (
      <button
        className={className}
        data-active={isActive}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {content}
        {tooltip}
      </button>
    );
  }

  return (
    <Link
      to={href}
      className={className}
      data-active={isActive}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {content}
      {tooltip}
    </Link>
  );
}

// Menú con submenús
function NavMenuWithChildren({
  item,
  isCollapsed,
  isExpanded,
  toggleMenu,
  isActive,
  onMouseEnter,
  onMouseLeave,
}: {
  item: NavItem;
  isCollapsed: boolean;
  isExpanded: boolean;
  toggleMenu: () => void;
  isActive: (href: string) => boolean;
  onMouseEnter?: (e: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave?: () => void;
}) {
  const hasActiveChild = item.children?.some((child) => isActive(child.href));  

  return (
    <div>
      <button
        onClick={toggleMenu}
        className={`
          relative w-full flex items-center gap-4 transition-all duration-200 group cursor-pointer
          focus:outline-none focus-visible:outline-none
          ${isCollapsed ? 'justify-center py-3' : 'px-6 py-3'}
          ${hasActiveChild ? 'bg-blue-50/80 text-blue-700' : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50'}
        `}
        data-active={hasActiveChild}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <span className={`flex-shrink-0 ${hasActiveChild ? 'text-blue-600' : 'text-slate-400 group-hover:text-slate-600'}`}>
          {item.icon}
        </span>
        <span
          className={`text-[14px] font-medium transition-all duration-300 overflow-hidden whitespace-nowrap ${isCollapsed ? 'w-0 opacity-0 hidden' : 'w-auto opacity-100 flex-1 text-left'
            }`}
        >
          {item.label}
        </span>
        {!isCollapsed && (
          <span className={`transition-transform duration-200 text-slate-400 ${isExpanded ? 'rotate-180' : ''}`}>
            {icons.chevronDown}
          </span>
        )}

      </button>

      {/* Submenú */}
      {!isCollapsed && (
        <div
          className={`overflow-hidden transition-all duration-300 ${isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
        >
          <div className="ml-4 pl-4 border-l border-gray-200 mt-1 space-y-1">
            {item.children?.map((child) => (
              <Link
                key={child.href}
                to={child.href}
                className={`
                  block px-3 py-2 text-sm rounded-lg transition-colors
                  ${isActive(child.href) ? 'text-gray-900 bg-gray-100 font-medium' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'}
                `}
              >
                {child.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
